import { render } from "./commissionConfig.vue?vue&type=template&id=d9b1e9aa&scoped=true"
import script from "./commissionConfig.vue?vue&type=script&lang=js"
export * from "./commissionConfig.vue?vue&type=script&lang=js"

import "./commissionConfig.vue?vue&type=style&index=0&id=d9b1e9aa&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b1e9aa"]])

export default __exports__